module.exports = __webpack_public_path__ + "static/seo-3983eb7ba2b96c1dc400ad7e45b6a988.jpg";